/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Page_Meta_TitleInputs */

const en_dashboard_page_meta_title = /** @type {(inputs: Dashboard_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard | Glider`)
};

const de_dashboard_page_meta_title = /** @type {(inputs: Dashboard_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht | Glider`)
};

const pt_br2_dashboard_page_meta_title = /** @type {(inputs: Dashboard_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel | Glider`)
};

const tr_dashboard_page_meta_title = /** @type {(inputs: Dashboard_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrol paneli | Glider`)
};

const zh_cn2_dashboard_page_meta_title = /** @type {(inputs: Dashboard_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仪表盘 | Glider`)
};

const zh_hk2_dashboard_page_meta_title = /** @type {(inputs: Dashboard_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儀表板 | Glider`)
};

const ko_kr2_dashboard_page_meta_title = /** @type {(inputs: Dashboard_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대시보드 | Glider`)
};

const ru_ru2_dashboard_page_meta_title = /** @type {(inputs: Dashboard_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель управления | Glider`)
};

const es_419_dashboard_page_meta_title = /** @type {(inputs: Dashboard_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel | Glider`)
};

/**
* | output |
* | --- |
* | "Dashboard \| Glider" |
*
* @param {Dashboard_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const dashboard_page_meta_title = /** @type {((inputs?: Dashboard_Page_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Page_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_page_meta_title(inputs)
	if (locale === "de") return de_dashboard_page_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_dashboard_page_meta_title(inputs)
	if (locale === "tr") return tr_dashboard_page_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_dashboard_page_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_dashboard_page_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_dashboard_page_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_dashboard_page_meta_title(inputs)
	return es_419_dashboard_page_meta_title(inputs)
});